var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCanadaFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5570_5838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 22.2109C17.5751 22.2109 22.5 17.2861 22.5 11.2109C22.5 5.13581 17.5751 0.210938 11.5 0.210938C5.42487 0.210938 0.5 5.13581 0.5 11.2109C0.5 17.2861 5.42487 22.2109 11.5 22.2109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5006 11.2112C22.5006 6.85017 19.9627 3.08198 16.2832 1.30273V21.1197C19.9627 19.3405 22.5006 15.5723 22.5006 11.2112V11.2112Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 11.2112C0.5 15.5723 3.03795 19.3405 6.71741 21.1198V1.30273C3.03795 3.08198 0.5 6.85017 0.5 11.2112Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.413 12.6459L15.326 11.6893L14.3695 11.2111V10.2546L12.4564 11.2111L13.413 9.29805H12.4564L11.4999 7.86328L10.5434 9.29805H9.58684L10.5434 11.2111L8.63031 10.2546V11.2111L7.67383 11.6893L9.58684 12.6459L9.1086 13.6024H11.0217V15.0372H11.9781V13.6024H13.8912L13.413 12.6459Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5570_5838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.5 0.210938)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanadaFlag);
export default __webpack_public_path__ + "static/media/canada-flag.92c1fe55b51136e3d34e0f1e4c91a9de.svg";
export { ForwardRef as ReactComponent };